<template>
  <div id="import-file" class="q-pa-md">
    <div class="crud-title"><translate>LATIS_GENERATION</translate></div>
    <crud ref="crudLayout" :name="name" :id="id"> </crud>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import IntegrationLatisController from './IntegrationLatisController'
import { JtCrud } from 'jtech-webcomps'
import pageStart from './PageStart'

const { CrudLayout } = JtCrud

@Component({
  name: 'IntegrationLatis',
  components: {
    crud: CrudLayout
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class IntegrationLatis extends Vue {
  controller = IntegrationLatisController.getInstance();
  fileSrc = null
  formatoGeracaoOnline = 1
  formatoRelatorioCsv = 7

  async mounted () {
    this.onButton()
    await this.addPageImportFile()
    this.$refs.crudLayout.setPage('import')
  }

  onButton () {
    this.$refs.crudLayout.onButton('btGenerateLatis', this.btGenerate)
    this.$refs.crudLayout.onButton('icDownload', this.icDownload)
    this.$refs.crudLayout.onButton('icSend', this.icSend)
  }

  async icSend ({ button, params, page, controller }) {
    await this.controller.sendLatis(params)
    page.$refs.jtDataTable.refresh()
  }

  async addPageImportFile () {
    const { forms, datatable } = await this.controller.generateLatis()
    if (this.$refs.crudLayout.$refs.containerRef.container.pages.length === 0) {
      this.$refs.crudLayout.addPage({
        type: 'form',
        name: 'import',
        label: this.$gettext('LATIS_GENERATION'),
        labelPage: this.$gettext('LATIS_GENERATION'),
        params: this.$refs.crudLayout.__loadParamsRouter({}),
        component: pageStart,
        flClose: false,
        forms: forms,
        datatable: datatable,
        parent: this
      })
    }
  }

  async generateFile ({ nmArquivo }) {
    try {
      const result = await this.$jt.repository.downloadFile(
        nmArquivo,
        7
      )
      this.fileSrc = URL.createObjectURL(result)

      this.$nextTick(() => {
        this.__downloadFile(this.fileSrc, 'integrationLatis.integrationLatis', '.csv')
      })
      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async icDownload ({ button, params, page, controller }) {
    try {
      const resolveLogicResult = await this.$jt.repository.resolveLogic(
        'integrationLatis.integrationLatis',
        { id: params.id, relFormaGeracao: this.formatoGeracaoOnline, relFormatoRelatorio: this.formatoRelatorioCsv }
      )

      await this.generateFile(resolveLogicResult)
    } catch (error) {
      console.error(error)
    }
  }

  __downloadFile (fileSrc, fileName = 'downloaded_file', extension = '.xls') {
    const link = document.createElement('a')
    link.style = 'display: none'
    link.download = `${fileName}${extension}`
    link.href = fileSrc
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  async btGenerate ({ button, params, page, controller }) {
    const forms = await this.controller.generate(params)
    page.$refs.jtDataTable.refresh()
  }
}
export default IntegrationLatis
</script>
<style lang="stylus"></style>
